import { ErrorLink } from '@apollo/client/link/error';
import { CombinedGraphQLErrors } from '@apollo/client/errors';
import { getMainDefinition } from '@apollo/client/utilities';
import { ownershipRefusalLocation } from '../utils/coexistence-entry';

/** Observe only; do not return a retry observable or replace the server error. */
export function coexistenceEntryNotice(onLocation: (locationId: string) => void): ErrorLink {
  return new ErrorLink(({ error, operation }) => {
    const definition = getMainDefinition(operation.query);
    if (definition.kind !== 'OperationDefinition' || definition.operation !== 'mutation') return;
    const locationId = CombinedGraphQLErrors.is(error) ? ownershipRefusalLocation(error.errors) : null;
    if (locationId) onLocation(locationId);
  });
}
